import React, { useState } from 'react';

export default function DashboardPostInput() {
  const [postText, setPostText] = useState('');

  const handlePost = () => {
    if (postText.trim()) {
      alert(`✅ Post submitted:\n${postText}`);
      setPostText('');
    }
  };

  return (
    <div className="bg-black rounded-lg shadow p-4 mb-6">
      <h2 className="text-sm font-semibold mb-2">💬 What's on your mind?</h2>

      <textarea
        value={postText}
        onChange={(e) => setPostText(e.target.value)}
        placeholder="Share an idea, signal, or update with the community..."
        className="w-full p-3 border rounded resize-none text-sm text-gray-700"
        rows={3}
      />

      <div className="mt-3 flex justify-between items-center">
        <button
          onClick={handlePost}
          className="bg-blue-600 text-white px-4 py-1.5 rounded hover:bg-blue-700 transition text-sm"
        >
          🚀 Post Update
        </button>

        <span className="text-xs text-gray-400">
          Public Post (signals, ideas, promo allowed)
        </span>
      </div>
    </div>
  );
}
